/**
 * PARAK effects — reveal-on-scroll, hero parallax, 3D tilt.
 * Dependency-free; safe to load from multiple sections (module executes once).
 * Respects prefers-reduced-motion.
 */

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/* Reveal styles only apply when JS is live — content stays visible otherwise */
document.documentElement.classList.add('parak-js');

/* ---------- Reveal on scroll ---------- */
const revealObserver = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('parak-inview');
        revealObserver.unobserve(entry.target);
      }
    }
  },
  { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
);

/* ---------- 3D tilt ---------- */
function bindTilt(el) {
  if (el.dataset.parakTiltBound || reducedMotion.matches) return;
  el.dataset.parakTiltBound = 'true';
  const strength = parseFloat(el.dataset.parakTilt) || 6;

  el.addEventListener('pointermove', (event) => {
    const rect = el.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    el.style.transform = `perspective(900px) rotateY(${x * strength}deg) rotateX(${y * -strength}deg)`;
  });

  el.addEventListener('pointerleave', () => {
    el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)';
  });
}

/* ---------- Hero parallax ---------- */
let parallaxTargets = [];
let ticking = false;

function onScroll() {
  if (ticking || reducedMotion.matches) return;
  ticking = true;
  requestAnimationFrame(() => {
    for (const el of parallaxTargets) {
      const speed = parseFloat(el.dataset.parakParallax) || 0.25;
      const rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        el.style.transform = `translate3d(0, ${window.scrollY * speed}px, 0)`;
      }
    }
    ticking = false;
  });
}

/* ---------- Scan / rescan (initial load + theme editor section loads) ---------- */
function scan(root = document) {
  for (const el of root.querySelectorAll('.parak-reveal:not(.parak-inview)')) revealObserver.observe(el);
  for (const el of root.querySelectorAll('[data-parak-tilt]')) bindTilt(el);
  parallaxTargets = [...document.querySelectorAll('[data-parak-parallax]')];
}

scan();
window.addEventListener('scroll', onScroll, { passive: true });
document.addEventListener('shopify:section:load', (event) => scan(event.target));
